module.exports = __webpack_public_path__ + "static/media/wps1.png.76ccf28d.jpg";